import { faXmark, faXmarkCircle } from "@fortawesome/pro-solid-svg-icons"
import { CircleIconButton } from "component_old/micro/action/CircleIconButton"
import {
  S_DesktopOnly,
  S_MobileOnly,
} from "component_old/micro/responsive/responsive"
import { S_AwesomeIcon } from "component_old/micro/view/AwesomeIcon"
import { CtxModal } from "component_old/modal/ctxModal"
import { ModalContent } from "component_old/modal/ModalContent"
import { motion } from "framer-motion"
import { EShadows } from "libs/style/styling"
import React, { useContext } from "react"
import styled from "styled-components/macro"

interface Props {
  className?: string
}

export const ModalWrapper = (props: Props): JSX.Element => {
  const ctxModal = useContext(CtxModal)

  return (
    <S_ModalWrapper>
      <S_Overlay
        className={props.className}
        onClick={() => {
          ctxModal.changeModal(null)
        }}
      />
      <S_MobileWrapper>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.1 }}
        >
          <S_MobileClose
            icon={faXmark}
            shadow={EShadows.LIGHT}
            type="primary"
            onClick={() => {
              ctxModal.changeModal(null)
            }}
          />
        </motion.div>
        <motion.div
          initial={{ y: "100vh" }}
          animate={{ y: "70px" }}
          transition={{
            delay: 0.1,
            y: { duration: 0.2 },
            default: { ease: "linear" },
          }}
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            zIndex: 101,
            boxSizing: "border-box",
            padding: "0 10px",
          }}
        >
          <S_MobileModal
            height={window.innerHeight - 70}
            modal={ctxModal.modal}
          >
            <ModalContent />
          </S_MobileModal>
        </motion.div>
      </S_MobileWrapper>
      <S_DesktopWrapper>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
        >
          <S_PCClose
            icon={faXmarkCircle}
            shadow={EShadows.LIGHT}
            type="primary"
            onClick={() => {
              ctxModal.changeModal(null)
            }}
            width={window.innerWidth}
          />
        </motion.div>
        <motion.div
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.2 }}
          style={{
            zIndex: 101,
            height: "fit-content",
          }}
        >
          <S_PCModal height={window.innerHeight - 150}>
            <ModalContent />
          </S_PCModal>
        </motion.div>
      </S_DesktopWrapper>
    </S_ModalWrapper>
  )
}

const S_ModalWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  justify-content: center;
`

const S_MobileWrapper = styled(S_MobileOnly)`
  width: 100%;
`

const S_DesktopWrapper = styled(S_DesktopOnly)`
  z-index: 101;
  height: fit-content;
`

const S_Overlay = styled.div`
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  @media only screen and (min-width: 1260px) {
    background: rgba(0, 0, 0, 0.8);
  }
`

const S_MobileModal = styled.div`
  width: 100%;
  height: ${props => props.height}px;
  border-top-right-radius: 7px;
  border-top-left-radius: 7px;
  overflow: hidden;
`

const S_PCModal = styled.div`
  width: 800px;
  max-height: ${props => props.height}px;
  margin: 75px 0 0 0;
  border-radius: 7px;
  overflow: hidden;
  background-color: white;
  z-index: 101;
  display: flex;
`

const S_MobileClose = styled(CircleIconButton)`
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 101;
  width: 50px;
  height: 50px;
  ${S_AwesomeIcon} {
    svg {
      font-size: 20px;
      margin: 2px 0 0 0;
    }
  }
`

const S_PCClose = styled(CircleIconButton)`
  position: absolute;
  top: 12px;
  z-index: 101;
  left: ${props => (props.width - 800) / 2 + 800}px;
`
